import React, { useEffect, useState, useRef } from 'react';
import { TableHeaderColumn } from "react-bootstrap-table";
import GridEmpty from '../../../../../Utils/Grid/GridEmpty';
import { columnaClaseFija } from '../../../../../../../utility/staticColumns';
import { 
    formatInvestmentCurrency,
    CurrencyDisplay
} from './CashFlowComponentsAnnual';
import './CashFlow.css';

const List = props => {
    const { data, loader, onSortChange, currency } = props;
    const tableRef = useRef(null);

    if (!data || !data.year_list || data.year_list.length === 0) {
        return <p>Cargando datos...</p>;
    }

    const dataExportable = data.investments && Array.isArray(data.investments.results) ? data.investments.results : [];

    const [collapsed, setCollapsed] = useState(false);

    const handleCollapseTable = () => {
        setCollapsed(!collapsed);
    };

    // Filtrar datos según el estado colapsado
    const getFilteredData = () => {
        if (!collapsed) {
            return dataExportable;
        }
        // Cuando está colapsado, mostrar solo el total
        return dataExportable.filter(row => row.name === 'TOTALES');
    };

    useEffect(() => {
        // Usar setTimeout para asegurar que la tabla se haya renderizado
        const timer = setTimeout(() => {
            const header = tableRef.current && tableRef.current.querySelector("thead");
            if (header) {
                header.addEventListener("click", handleCollapseTable);
                header.style.cursor = 'pointer';
            }
        }, 100);

        return () => {
            clearTimeout(timer);
            const header = tableRef.current && tableRef.current.querySelector("thead");
            if (header) {
                header.removeEventListener("click", handleCollapseTable);
            }
        };
    }, [collapsed, dataExportable]);

    const formatearNumero = (dato, row) => {
        if (row.isTitulo) {
            return '';
        }

        return <span style={{ color: '#dc3545', fontWeight: '500' }}>
            {formatInvestmentCurrency(dato, currency)}
        </span>;
    };

    const estilosNombre = (cell, row) => {
        if (row.isTitulo) {
            return { fontWeight: 'bold', color: 'black' };
        }
        return {};
    };

    const columnaClaseTotal = (cell, row) => {
        if (row.name === 'TOTALES') {
            return 'celda-totales';
        }
        return '';
    };

    const columnas = data.year_list.map((year, index) => (
        <TableHeaderColumn
            key={index}
            dataField={year.toString()}
            dataSort
            dataFormat={(cell, row) => formatearNumero(cell, row)}
            columnClassName={columnaClaseTotal}
            width='130'
            tdStyle={{ color: '#dc3545', fontWeight: '500' }}
        >
            {year}
        </TableHeaderColumn>
    ));

    return (
        <div className="investment-flow" ref={tableRef}>
            <GridEmpty
                hover
                striped
                data={getFilteredData()}
                loading={loader}
                onSortChange={onSortChange}
                pagination={false}
                className="pb-3 report-scroll-content cash-flow"
            >
                <TableHeaderColumn
                    dataField="name"
                    isKey={true}
                    dataSort
                    className="table-fixed-cell-left-0"
                    width='170'
                    columnClassName={columnaClaseFija}
                    tdStyle={(cell, row) => row.isTitulo ? { fontWeight: 'bold', color: 'black' } : { color: '#dc3545', fontWeight: '500' }}
                    columnStyle={(cell, row) => estilosNombre(cell, row)}
                >
                    FLUJO DE INVERSIÓN {collapsed ? '(Click para expandir)' : '(Click para colapsar)'}
                </TableHeaderColumn>
                {columnas}
            </GridEmpty>
        </div>
    );
};

export default List;
